import * as OM from '@/model';
import { Options, Vue } from 'vue-class-component';
import * as VM from '@/viewmodel';
import { createStore, StoreOptions } from 'vuex';
import { StorageServices } from '@/services/StorageServices';
import getModules from '@/moduleLoader';
import { RouteLocationNormalizedLoadedGeneric } from 'vue-router';

let state = {
    showSpinner: 0,
    loginData: <OM.LoginData>null,
    user: <OM.BaseUser>null,
    selectedLanguage: '',
    layoutSlugs: <VM.LayoutSlug[]>[],
    layoutSlugButtonAdd: <VM.ButtonSettings>null,
    projectColors: <OM.ProjectColors>{},
    consts: {
        localizedValues: [],
        enabledLanguages: [],
        projectConfig: <OM.ProjectConfigVm>{
            name: "",
            colors: new OM.ProjectColors(),
            logoUrl: ""
        },
        country: "",
    },
    modules: <VM.ModuleConfig[]>[],
    pageTitle: "",
    routeBuster: false,
    beforeNavCbs: <((to: RouteLocationNormalizedLoadedGeneric, from: RouteLocationNormalizedLoadedGeneric) => void)[]>[],
    afterNavCbs: <((to: RouteLocationNormalizedLoadedGeneric, from: RouteLocationNormalizedLoadedGeneric) => void)[]>[],
    formErrors: <{ [key: string]: boolean }>{},
    copyToClipboard: copyToClipboard,
    isAdmin: (input?: string) => {
        let checkWith = input ? input : state.user && state.user.role;
        return checkWith == "Admin";
    },
    isLead: (input?: string) => {
        let checkWith = input ? input : state.user && state.user.type;
        return checkWith == "Lead";
    },
    isCustomer: (input?: string) => {
        let checkWith = input ? input : state.user && state.user.type;
        return checkWith == "Customer";
    },
    isOperator: (input?: string) => {
        let checkWith = input ? input : state.user && state.user.type;
        return checkWith == "Operator";
    },
    isDoctor: (input?: string) => {
        let checkWith = input ? input : state.user && state.user.type;
        return checkWith == "Doctor";
    },
}


let vuestore: StoreOptions<typeof state> = {
    state: state,
	mutations: {
		showSpinner(state){
            state.showSpinner++;
		},
		hideSpinner(state){
            state.showSpinner--;
            if(state.showSpinner < 0){
                state.showSpinner = 0;
            }
        }
	},
}

let store = createStore(vuestore);

export default store

store.state.modules = getModules()

store.state.loginData = StorageServices.getLoginData();
store.state.selectedLanguage = StorageServices.getSelectedLanguage();
store.state.projectColors = StorageServices.getProjectColors() || <OM.ProjectColors>{};

function copyToClipboard(text, clickEv: MouseEvent = null) {
    var dummy = document.createElement("textarea");
    // to avoid breaking orgain page when copying more words
    // cant copy when adding below this code
    // dummy.style.display = 'none'
    document.body.appendChild(dummy);
    //Be careful if you use texarea. setAttribute('value', value), which works with "input" does not work with "textarea". – Eduard
    dummy.value = text;
    dummy.select();
    document.execCommand("copy");
    document.body.removeChild(dummy);
    
    if(clickEv){
        var popup = document.createElement("div");
        popup.style.position = "fixed";
        popup.style.left = clickEv.clientX + "px";
        popup.style.top = clickEv.clientY + "px";
        popup.style.backgroundColor = "white";
        popup.style.border = "1px solid grey";
        popup.style.pointerEvents = "none";
        popup.style.touchAction = "none";
        popup.innerHTML = require('@/img/common/check.png'); // "<img src=\"https://upload.wikimedia.org/wikipedia/commons/thumb/e/e9/Check_mark.svg/220px-Check_mark.svg.png\" />";
        document.body.append(popup);
        setTimeout(() => {
            popup.remove();
        }, 400);
    }

}